const INITIAL_STATE = {
  funcionarios: {
    data: []
  },
  funcionario: null,
  pessoa: {},
  fisica: {},
  setor: {},
  endereco: {},
  funcEndereco: {},
  contasBancarias: [],
  contaBancaria: null,
  contatos: [],
  funcionarioPesquisa: [],
  telefones: [],
  funcionarioEditar: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'FUNCIONARIO_FETCH':
      return { ...state, funcionarios: action.payload }
    case 'FUNCIONARIO_PESQUISA_FETCH':
      return { ...state, funcionarioPesquisa: action.payload }
    case 'FUNCIONARIO_SET':
      return {
        ...state,
funcionario: action.payload.funcionario,
        pessoa: action.payload.pessoal,
        fisica: action.payload.pessoal.fisica,
        endereco: action.payload.endereco,
        contatos: action.payload.contato
      }
    case 'FUNCIONARIO_GET':
      const funcionario = { ...state.funcionarioPessoal }
      funcionario[action.payload.propriedade] = action.payload.value
      return { ...state, funcionario, funcionarioEditar: action.payload }
    case 'FUNCIONARIO_PESSOA_SET':
      const pessoa = { ...state.pessoa }
      pessoa[action.payload.propriedade] = action.payload.value
      return { ...state, pessoa }
    case 'FUNCIONARIO_FISICA_SET':
      const fisica = { ...state.fisica }
      fisica[action.payload.propriedade] = action.payload.value
      return { ...state, fisica }
    case 'FUNCIONARIO_ENDERECO_SET':
      const endereco = { ...state.funcEndereco }
      endereco[action.payload.propriedade] = action.payload.value
      return { ...state, funcEndereco: endereco }
    case 'FUNCIONARIO_BANCO_SET':
      const banco = { ...state.funcionarioBanco }
      banco[action.payload.propriedade] = action.payload.value
      return { ...state, funcionarioBanco: banco }
    case 'FUNCIONARIO_CONTA_BANCARIA':
      return { ...state, contaBancaria: action.payload }
    case 'FUNCIONARIO_CONTAS_BANCARIAS_FETCH':
      return { ...state, contasBancarias: action.payload }
      case 'TELEFONES_FETCH':
        return { ...state, telefones: action.payload }
    default:
      return state
  }
}